import React from "react";

export default function DashboardGrid({ children }) {

    // Convert children to array
    const childArray = React.Children.toArray(children);

    // Count flexible rows (no height prop)
    const flexibleRows = childArray.filter(function (child) {
        return !child.props.height;
    });

    const flexCount = flexibleRows.length;

    return (
        <div style={container}>
            {childArray.map(function (child, index) {

                const hasFixedHeight = child.props.height;

                let style = {};

                if (hasFixedHeight) {
                    style.height = child.props.height;
                } else {
                    style.flex = flexCount > 0 ? 1 : 0;
                    style.minHeight = 0; // 🔥 critical
                }

                return React.cloneElement(child, {
                    key: index,
                    style: {
                        ...(child.props.style || {}),
                        ...style
                    }
                });

            })}
        </div>
    );
}

const container = {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    gap: "20px"
};